import { storage as storageService } from '../../services/storageServices';

const hasDeviceId = (): boolean => {
  const deviceId = storageService.getItem('flipdish-device-id');
  return deviceId !== null;
};

const hasSafariUserAgent = (): boolean => {
  const userAgent =
    navigator.vendor &&
    navigator.vendor.indexOf('Apple') > -1 &&
    navigator.userAgent;
  return !!userAgent;
};

export const setCookieUtils = {
  hasDeviceId,
  hasSafariUserAgent,
};
